import { FormControl, Grid, IconButton, Tooltip, InputLabel, Select, TextField, Typography, Box, Autocomplete } from '@mui/material';
import { Search as IconSearch } from "@mui/icons-material";
import api from "../../services/api";
import moment from 'moment';
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setValueEntity, setEntity
    , setTipos, setValidations, initPerson, defaultEntity } from "../../redux/person/personLegalSlice";
import UbigeoSearch from '../UbigeoSearch';
import { FormHelperText as HelperText } from '@mui/material';
import * as personaService from "../../services/personaService";
import * as catalogoService from "../../services/catalogoService";

const PersonaJuridica = (props) => {
    const dispatch = useDispatch();
    const sliceKey = props.sliceKey;
    const isReadOnly = props.isReadOnly;
    const inputRef = useRef(null);

    useEffect(() => {
        dispatch(initPerson({ sliceKey }));
    }, [dispatch, sliceKey]);

    useEffect(() => {
        if (props.autoFocus) {
        const timer = setTimeout(() => inputRef.current?.focus(), 150);
        return () => clearTimeout(timer);
        }
    }, [props.autoFocus]);

    const fechaIngresoMinimo = new Date(2010, 1, 1);

    const entity = useSelector((state) => state.personLegal[sliceKey]?.entity);
    const validate = useSelector((state) => state.personLegal[sliceKey]?.validationActive);
    const tipos = useSelector((state) => state.personLegal[sliceKey]?.tipos);

    var validation = {
        razonSocial: {
            error: entity?.razonSocial != null && entity?.razonSocial?.length < 3,
            message: "Falta ingresar la razón social",
        },
        idTipo: {
            error: entity?.idTipo === 0,
            message: "Falta ingresar el tipo de persona juridica",
        },
        fechaIngreso: {
            error: Date.parse(entity?.fechaIngreso) < fechaIngresoMinimo,
            message: "Debe ser una fecha mayor al " + fechaIngresoMinimo.getFullYear(),
        },
    }

    const fetchPersonaJuridica = async () => {
        const response = await personaService.getPersonaJuridica(props.id);
        dispatch(setEntity({sliceKey: sliceKey, data: response ? response : defaultEntity}));
    }
    const fetchTipos = async () => {
        const response = await catalogoService.getCatalogosByPadre(147);
        dispatch(setTipos({sliceKey: sliceKey, data: response}));
    }

    useEffect(() => {
        fetchPersonaJuridica();
        fetchTipos();
        dispatch(setValidations({sliceKey: sliceKey, message: messagesValidation()}));
    }, []);

    useEffect(() => {
        dispatch(setValidations({sliceKey: sliceKey, message: messagesValidation()}));
    }, [entity])

    var handleChange = e => {
        dispatch(setValueEntity({sliceKey: sliceKey, name: e.target.name, value: e.target.value}));
    }
    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }
    
    return (
        <Grid container>
            <Grid item>
                <Box sx={{ fontWeight: 'bold' }} padding={0}>
                    <Typography variant="h7">
                        Datos Basicos
                    </Typography>
                </Box>
            </Grid>
            <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                <Grid item xs={12} sm={8}>
                    <TextField
                        required
                        name="razonSocial"
                        label="Razon Social"
                        fullWidth
                        value={entity?.razonSocial || ""}
                        onChange={handleChange}
                        error={validate?.razonSocial && validation.razonSocial.error}
                        helperText={validate?.razonSocial && validation.razonSocial.error ? validation.razonSocial.message : ""}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        disabled={isReadOnly}
                        inputRef={inputRef}
                    />
                </Grid>
                <Grid item xs={6} sm={2}>
                    <TextField
                        required
                        name="fechaIngreso"
                        label="Fecha Ingreso"
                        fullWidth
                        type="date"
                        value={moment(entity?.fechaIngreso || moment()).format('yyyy-MM-DD')}
                        onChange={handleChange}
                        error={validate?.fechaIngreso && validation.fechaIngreso.error}
                        helperText={validate?.fechaIngreso && validation.fechaIngreso.error ? validation.fechaIngreso.message : ""}
                        size="small"
                        disabled={isReadOnly}
                    />
                </Grid>
                <Grid item xs={6} sm={2}>
                    <FormControl required fullWidth error={validate?.idTipo && validation.idTipo.error}>
                        <InputLabel htmlFor="input-tipo">Tipo</InputLabel>
                        <Select
                            native
                            label="Tipo"
                            value={entity?.idTipo || 0}
                            fullWidth
                            onChange={handleChange}
                            inputProps={{
                                name: 'idTipo',
                                id: 'input-tipo',
                            }}
                            size="small"
                            disabled={isReadOnly}
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {tipos?.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        <HelperText>{validate?.idTipo && validation.idTipo.error ? validation.idTipo.message : ""}</HelperText>
                    </FormControl>
                </Grid>
            </Grid>
        </Grid>
    );
}
export default PersonaJuridica;
